import { AfterViewInit, Component, inject, OnInit, ViewChild, ElementRef } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "../../../core/services/auth.service";
import { CommonModule } from "@angular/common";
import { FullCalendarModule } from "@fullcalendar/angular";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import esLocale from '@fullcalendar/core/locales/es';
import * as moment from 'moment-timezone';
import { MatIconModule } from '@angular/material/icon';
import { MatCalendar } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { ObjectivesService } from "../../../core/services/objectives.service";
import { TestsService } from "../../../core/services/tests.service";
import { LoaderService } from "../../../core/shared/services/loader.service";
import { SUBSCRIPTION_TYPES, TEST_TYPES, USER_TYPES } from "../../../core/shared/constants";
import { Activity, Objective } from "../../../core/models/objective.model";
import { AuthUser } from "../../../core/models/auth/auth.interface";
import { ProgressSummaryComponent } from "../../../core/shared/components/progress-summary/progress-summary.component";
import { TableComponent } from "../descubrete/objectives/table/table.component";
import { AppointmentsService } from "../../../core/services/appointments.service";
import { Appointment } from "../../../core/models/appointment.model";
import { environment } from "../../../../environments/environment";
import { VideoModalComponent } from "../video-modal/video-modal.component";
import { YouTubePlayerComponent } from "../../../core/shared/components/youtube-player/youtube-player.component";
import { WaitlistService } from "../../../core/services/waitlist.service";
import { EmailService, EmailData } from "../../../core/services/email.service";
import Swal from "sweetalert2";
import { SafePipe } from "../../../core/shared/pipes";

moment.tz.setDefault('America/Lima');

interface ObjetivoUI {
  _id: string;
  nombre: string;
  dimension: string;
  fin: string;
  porcentaje: number;
  activities?: ActividadUI[];
  state: string;
}

interface ActividadUI {
  nombre: string;
  descripcion: string;
  progreso: number;
  estado: string;
  inicio: string;
  fin: string;
}

interface Curso {
  id: string;
  titulo: string;
  vistas: number;
  duracion: number;
  imagen: string;
}

interface EntradaBlog {
  id: string;
  titulo: string;
  extracto: string;
  fecha: string;
}

@Component({
  selector: "app-dashboard-menu",
  standalone: true,
  imports: [
    CommonModule,
    FullCalendarModule,
    MatIconModule,
    MatCalendar,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
    ProgressSummaryComponent,
    TableComponent,
    RouterModule,
    VideoModalComponent,
    YouTubePlayerComponent,
    SafePipe
  ],
  templateUrl: "./dashboard-menu.component.html",
  styleUrl: "./dashboard-menu.component.scss",
})
export class DashboardMenuComponent implements OnInit, AfterViewInit {
  private authService: AuthService = inject(AuthService);
  authUser: AuthUser = this.authService.getAuthUser()!;
  user: any = null; // Variable para los datos completos del usuario
  private objectivesService: ObjectivesService = inject(ObjectivesService);
  private testsService: TestsService = inject(TestsService);
  private loader = inject(LoaderService);
  private appointmentsService = inject(AppointmentsService);
  private waitlistService = inject(WaitlistService);
  private emailService = inject(EmailService);

  // Calendario
  selectedDate: Date | null = null;
  calendarPlugins = [dayGridPlugin, timeGridPlugin, momentTimezonePlugin];
  currentWeekRange = this.getStartAndEndOfWeek();

  // Fecha actual
  currentDate: Date = new Date();

  // Datos del calendario
  timeSlots: string[] = ['7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22'];
  weekDays: any[] = [];
  miniCalendarDays: any[] = [];
  currentMonth: Date = new Date();
  currentMonthYear: string = '';

  // Datos de Agenda
  agenda: any[] = [];


  // Variables para la vista del calendario
  currentView: 'week' | 'day' | 'month' = 'week'; // Se establecerá dinámicamente en ngOnInit
  selectedDayIndex: number = 0;
  selectedDay: any = null;
  currentWeekStart: Date = new Date();

  // Variables para el calendario móvil
  mobileSelectedDayIndex: number = -1; // -1 indica que no se ha inicializado
  mobileSelectedDay: any = null;

  // Objetivos y progreso
  objetivos: ObjetivoUI[] = [];
  objetivosFiltrados: ObjetivoUI[] = []; // Array para los objetivos filtrados
  objetivosOriginales: Objective[] = [];
  totalPorcentajeObjetivos: number = 0;
  totalObjetivos: number = 0;
  totalObjetivosCompletados: number = 0;

  // Propiedades para el filtro
  estadosFiltro: string[] = ["Todos", "Nuevo", "Pendiente", "Empezado", "Completado"];
  estadoSeleccionado: string = "Todos";

  // Estadísticas de objetivos
  objectviesStarted: number = 0;
  objectivesPending: number = 0;
  objectivesFinished: number = 0;

  // Actividades
  actividades: ActividadUI[] = [];

  // Datos de test de autoconocimiento
  tests: any[] = [];
  testsCompleted: number = 0;
  dimensionsCompleted: number = 0;
  autoconocimientoProgress: number = 0;

  // Secciones de progreso
  progresoOnboarding: boolean = false;
  progresoDescubrete: boolean = false;
  progresoPRD: boolean = false;
  progresoRevision: boolean = false;

  // Mentores y expertos
  showHoursMentorModal: boolean = false;
  horasMentores: number = 0;
  horasExpertos: number = 0;

  horasTotalesMentores: number = 0;
  horasTotalesExpertos: number = 0;

  // Academy y blog
  cursos: Curso[] = [];
  blog: EntradaBlog[] = [];

  // Configuración del calendario
  calendarOptions: any;

  // Estados para manejar mensajes informativos
  messageHide: boolean = true;

  // Fecha actual formateada
  dateToday: string = new Date().toLocaleDateString("es-ES", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  cards = [
    {
      title: "Objetivo",
      subtitle: "Resumen",
      progressType: "spinner",
      progressValue: 0,
    },
    {
      title: "Mentores",
      subtitle: "24h en tu Plan",
      progressType: "bar",
      progressValue: 75,
    },
    {
      title: "Expertos",
      subtitle: "24h en tu Plan",
      progressType: "bar",
      progressValue: 5,
    },
  ];

  userAppointments: Appointment[] = [];

  // Modal para preselección Executive
  showExecutiveModal: boolean = false;

  // Modal para detalles de cita
  showAppointmentModal: boolean = false;
  selectedAppointment: Appointment | null = null;

  // Valores generados para el modal de cita (se generan una sola vez)
  private meetingId: string = '';
  private accessCode: string = '';
  private meetingLink: string = '';

  // Control del sidebar móvil
  showMobileSidebar: boolean = false;

  // Propiedad para almacenar el estado Freemium (evita bucles)
  private _isUserFreemium: boolean = false;

  // Propiedades para almacenar estados del calendario (evitan bucles)
  private _isTodaySelected: boolean = false;
  private _isDayViewActive: boolean = false;
  private _isNavigatingMonth: boolean = false;

  // Variable para mostrar el banner de felicitaciones por salario alto
  showSalaryBanner: boolean = false;
  isHighSalaryUser: boolean = false;

  // Modal de lista de espera
  showWaitlistModal: boolean = false;
  isSubmittingWaitlist: boolean = false;
  waitlistForm = {
    nombre: '',
    apellido: '',
    telefono: '',
    correoElectronico: '',
    provincia: '',
    distrito: ''
  };

  // Provincias y distritos para el formulario de lista de espera
  provincias = [
    'Amazonas', 'Ancash', 'Apurímac', 'Arequipa', 'Ayacucho', 'Cajamarca',
    'Callao', 'Cusco', 'Huancavelica', 'Huánuco', 'Ica', 'Junín', 'La Libertad',
    'Lambayeque', 'Lima', 'Loreto', 'Madre de Dios', 'Moquegua', 'Pasco',
    'Piura', 'Puno', 'San Martín', 'Tacna', 'Tumbes', 'Ucayali'
  ];

  distritos: { [key: string]: string[] } = {
    'Lima': ['Ancón', 'Ate', 'Barranco', 'Breña', 'Carabayllo', 'Chaclacayo', 'Chorrillos', 'Cieneguilla', 'Comas', 'El Agustino', 'Independencia', 'Jesús María', 'La Molina', 'La Victoria', 'Lince', 'Los Olivos', 'Lurigancho', 'Lurín', 'Magdalena del Mar', 'Miraflores', 'Pachacámac', 'Pucusana', 'Pueblo Libre', 'Puente Piedra', 'Punta Hermosa', 'Punta Negra', 'Rímac', 'San Bartolo', 'San Borja', 'San Isidro', 'San Juan de Lurigancho', 'San Juan de Miraflores', 'San Luis', 'San Martín de Porres', 'San Miguel', 'Santa Anita', 'Santa María del Mar', 'Santa Rosa', 'Santiago de Surco', 'Surquillo', 'Villa El Salvador', 'Villa María del Triunfo'],
    'Arequipa': ['Arequipa', 'Alto Selva Alegre', 'Cayma', 'Cerro Colorado', 'Characato', 'Chiguata', 'Jacobo Hunter', 'La Joya', 'Mariano Melgar', 'Miraflores', 'Mollebaya', 'Paucarpata', 'Pocsi', 'Polobaya', 'Quequeña', 'Sabandía', 'Sachaca', 'San Juan de Siguas', 'San Juan de Tarucani', 'Santa Isabel de Siguas', 'Santa Rita de Siguas', 'Socabaya', 'Tiabaya', 'Uchumayo', 'Vitor', 'Yanahuara', 'Yarabamba', 'Yura'],
    'Cusco': ['Cusco', 'Ccorca', 'Poroy', 'San Jerónimo', 'San Sebastian', 'Santiago', 'Saylla', 'Wanchaq'],
    'Piura': ['Piura', 'Castilla', 'Catacaos', 'Cura Mori', 'El Tallan', 'La Arena', 'La Unión', 'Las Lomas', 'Tambo Grande', 'Veintiséis de Octubre'],
    'La Libertad': ['Trujillo', 'El Porvenir', 'Florencia de Mora', 'Huanchaco', 'La Esperanza', 'Laredo', 'Moche', 'Poroto', 'Salaverry', 'Simbal', 'Victor Larco Herrera'],
    'Lambayeque': ['Chiclayo', 'Chongoyape', 'Eten', 'Eten Puerto', 'José Leonardo Ortiz', 'La Victoria', 'Lagunas', 'Monsefú', 'Nueva Arica', 'Oyotún', 'Picsi', 'Pimentel', 'Reque', 'San José', 'Santa Rosa', 'Saña', 'Cayalti', 'Pátapo', 'Pomalca', 'Pucalá', 'Tuman'],
    'Junín': ['Huancayo', 'Chacapampa', 'Chanchamayo', 'Chicche', 'Chilca', 'Chongos Alto', 'Chupaca', 'Colca', 'Cullhuas', 'El Tambo', 'Huacrapuquio', 'Hualhuas', 'Huancan', 'Huasicancha', 'Huayucachi', 'Ingenio', 'Pariahuanca', 'Pilcomayo', 'Pucara', 'Quichuay', 'Quilcas', 'San Agustín', 'San Jerónimo de Tunan', 'Saño', 'Sapallanga', 'Sicaya', 'Santo Domingo de Acobamba', 'Viques'],
    'Callao': ['Callao', 'Bellavista', 'Carmen de la Legua Reynoso', 'La Perla', 'La Punta', 'Ventanilla', 'Mi Perú'],
    'Ancash': ['Huaraz', 'Cochabamba', 'Colcabamba', 'Huanchay', 'Independencia', 'Jangas', 'La Libertad', 'Olleros', 'Pampas Grande', 'Pariacoto', 'Pira', 'Tarica'],
    'Ica': ['Ica', 'La Tinguiña', 'Los Aquijes', 'Ocucaje', 'Pachacutec', 'Parcona', 'Pueblo Nuevo', 'Salas', 'San José de Los Molinos', 'San Juan Bautista', 'Santiago', 'Subtanjalla', 'Tate', 'Yauca del Rosario'],
    'Tacna': ['Tacna', 'Alto de la Alianza', 'Calana', 'Ciudad Nueva', 'Inclan', 'Pachia', 'Palca', 'Pocollay', 'Sama', 'Coronel Gregorio Albarracín Lanchipa'],
    'Puno': ['Puno', 'Acora', 'Amantani', 'Atuncolla', 'Capachica', 'Chucuito', 'Coata', 'Huata', 'Mañazo', 'Paucarcolla', 'Pichacani', 'Plateria', 'San Antonio', 'Tiquillaca', 'Vilque'],
    'Cajamarca': ['Cajamarca', 'Asunción', 'Cospan', 'Encañada', 'Jesús', 'Llacanora', 'Los Baños del Inca', 'Magdalena', 'Matara', 'Namora', 'San Juan'],
    'Ayacucho': ['Huamanga', 'Acos Vinchos', 'Andrés Avelino Cáceres Dorregaray', 'Ayacucho', 'Carmen Alto', 'Chiara', 'Ocros', 'Pacaycasa', 'Quinua', 'San José de Ticllas', 'San Juan Bautista', 'Santiago de Pischa', 'Socos', 'Tambillo', 'Vinchos'],
    'Huancavelica': ['Huancavelica', 'Acobambilla', 'Acoria', 'Conayca', 'Cuenca', 'Huachocolpa', 'Huayllahuara', 'Laria', 'Manta', 'Mariscal Cáceres', 'Moya', 'Nuevo Occoro', 'Palca', 'Pilchaca', 'Vilca', 'Yauli'],
    'Huánuco': ['Huánuco', 'Amarilis', 'Chinchao', 'Churubamba', 'Margos', 'Quisqui', 'San Francisco de Cayran', 'San Pedro de Chaulan', 'Santa María del Valle', 'Yarumayo', 'Pillco Marca', 'Yacus'],
    'Loreto': ['Maynas', 'Alto Nanay', 'Fernando Lores', 'Indiana', 'Las Amazonas', 'Mazán', 'Napo', 'Punchana', 'Putumayo', 'Torres Causana', 'Belén', 'San Juan Bautista', 'Teniente Manuel Clavero'],
    'Ucayali': ['Coronel Portillo', 'Callería', 'Campoverde', 'Iparía', 'Masisea', 'Yarinacocha', 'Nueva Requena'],
    'San Martín': ['Moyobamba', 'Calzada', 'Habana', 'Jepelacio', 'Soritor', 'Yantalo'],
    'Madre de Dios': ['Tambopata', 'Inambari', 'Las Piedras', 'Laberinto'],
    'Moquegua': ['Moquegua', 'Carumas', 'Cuchumbaya', 'Omate', 'Quinistaquillas', 'Samegua'],
    'Pasco': ['Cerro de Pasco', 'Chaupimarca', 'Huachon', 'Huariaca', 'Huayllay', 'Ninacaca', 'Pallanchacra', 'Paucartambo', 'San Francisco de Asis de Yarusyacan', 'Simon Bolivar', 'Ticlacayan', 'Tinyahuarco', 'Vicco', 'Yanacancha'],
    'Apurímac': ['Abancay', 'Chacoche', 'Circa', 'Curahuasi', 'Huanipaca', 'Lambrama', 'Pichirhua', 'San Juan de Chacña', 'Tamburco'],
    'Amazonas': ['Chachapoyas', 'Asunción', 'Balsas', 'Cheto', 'Chiliquin', 'Chuquibamba', 'Granada', 'Huancas', 'La Jalca', 'Leimebamba', 'Levanto', 'Magdalena', 'Mariscal Castilla', 'Molinopampa', 'Montevideo', 'Olleros', 'Quinjalca', 'San Francisco de Daguas', 'San Isidro de Maino', 'Soloco', 'Sonche'],
    'Tumbes': ['Tumbes', 'Corrales', 'La Cruz', 'Pampas de Hospital', 'San Jacinto', 'San Juan de la Virgen', 'Zorritos']
  };

  // Historial de Compras
  showModalPurchaseSummary: boolean = false;
  currentPage: number = 1;
  totalPages: number = 0;
  paginatedData: any[] = [];
  itemsPerPage: number = 5;

  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  // Propiedades para el botón flotante y modal de video
  showVideoModal: boolean = false;
  shouldAutoPlayVideo: boolean = false;

  // ViewChild para el reproductor de YouTube
  @ViewChild('youtubePlayer', { static: false }) youtubePlayer!: ElementRef;

  constructor(private router: Router) { }

  ngOnInit() {
    this.setupCalendarOptions();
    this.initializeWeekDays();
    this.initializeMiniCalendar();

    // Establecer vista por defecto basada en el tamaño de pantalla
    this.setDefaultView();

    // Agregar listener para redimensionamiento de ventana
    window.addEventListener('resize', () => {
      this.setDefaultView();
    });

    // No llamamos checkAutoPlayVideo aquí porque this.user aún no está disponible
    // Se llamará después de cargar los datos del usuario
  }

  ngAfterViewInit(): void {

    this.loader.show();

    // Realizamos múltiples llamadas en paralelo
    Promise.all([
      // Primero, cargamos los datos completos del usuario
      new Promise<void>((resolve) => {
        this.authService.findUserById(this.authUser.id).subscribe({
          next: (userResponse) => {
            if (userResponse && userResponse.data) {
              this.user = userResponse.data;
              // Cargar datos del usuario después de asignar el usuario
              this.loadUserData();
              this.loadAppointments();
              this.updateCalendarStates();
              // Ahora que this.user está disponible, verificamos si debe reproducir el video
              this.checkAutoPlayVideo();
            }
            resolve();
          },
          error: (error) => {
            console.error("Error al cargar datos del usuario:", error);
            resolve();
          },
        });
      }),

      // Cargamos los objetivos
      new Promise<void>((resolve) => {
        this.objectivesService.findAll(this.authUser.id).subscribe({
          next: (response) => {
            console.log("Respuesta de objetivos:", response);

            if (response && response.data && Array.isArray(response.data)) {
              this.objetivosOriginales = response.data;
              this.procesarObjetivos();
            }
            resolve();
          },
          error: (error) => {
            console.error("Error al cargar objetivos:", error);
            resolve();
          },
        });
      }),

      // Cargamos los tests de autoconocimiento
      new Promise<void>((resolve) => {
        this.testsService
          .find(this.authUser.id, TEST_TYPES.Autoconocimiento.id)
          .subscribe({
            next: (response) => {
              console.log("Respuesta de tests:", response);

              if (response && response.data) {
                this.tests = response.data;
                this.calcularProgresoAutoconocimiento();
              }
              resolve();
            },
            error: (error) => {
              console.error("Error al cargar tests:", error);
              resolve();
            },
          });
      }),
    ]).finally(() => {
      this.loader.hide();
    });
  }

  setupCalendarOptions() {

    console.log('currentWeekRange', this.currentWeekRange);

    const events = this.userAppointments.map(x => ({ title: x.coach.name, date: x.dateValue }));
    const isMobile = window.innerWidth < 768;

    this.calendarOptions = {
      timeZone: "America/Lima",
      locale: esLocale,
      initialView: isMobile ? "timeGridDay" : "timeGridWeek",
      weekends: true,
      plugins: this.calendarPlugins,
      events: events || [],
      headerToolbar: isMobile
        ? {
          left: "prev,next title",
          center: "",
          right: "today",
        }
        : {
          left: "prev,next title",
          center: "",
          right: "timeGridWeek,timeGridDay today",
        },
      slotMinTime: "07:00:00",
      slotMaxTime: "22:00:00",
      slotDuration: "00:30:00",
      nowIndicator: true,
      validRange: {
        // Kept from original, defines the navigable range
        start: this.currentWeekRange.start,
        end: this.currentWeekRange.end,
      },
      firstDay: 0,
      initialDate: this.currentWeekRange.start, // Start view at the beginning of the current week
      allDaySlot: false,
      height: "auto", // Let the container's CSS dictate height
      handleWindowResize: true, // Enable FullCalendar's internal resize handling
      windowResizeDelay: 200, // Debounce resize events
      windowResize: (arg: any) => {
        const currentIsMobile = window.innerWidth < 768;
        if (currentIsMobile) {
          if (!arg.calendar) return
          if (arg.calendar.view.type !== "timeGridDay") {
            arg.calendar.changeView("timeGridDay");
          }
          arg.calendar.setOption("headerToolbar", {
            left: "prev,next title",
            center: "",
            right: "today",
          });
        } else {
          // Desktop
          if (arg.calendar.view.type !== "timeGridWeek") {
            arg.calendar.changeView("timeGridWeek");
          }
          arg.calendar.setOption("headerToolbar", {
            left: "prev,next title",
            center: "",
            right: "timeGridWeek,timeGridDay today",
          });
        }
      },
    };
  }

  // Establecer vista por defecto basada en el tamaño de pantalla
  setDefaultView() {
    if (window.innerWidth <= 768) {
      // En móvil, vista por defecto es 'week'
      this.currentView = 'week';
    } else {
      // En desktop, vista por defecto es 'month'
      this.currentView = 'month';
    }
  }

  // Cálculo avanzado del progreso de autoconocimiento
  calcularProgresoAutoconocimiento() {
    this.testsCompleted = 0;
    this.dimensionsCompleted = 0;
    let dimensionsTotalCount = 0;

    // Analizar cada test y sus dimensiones
    this.tests.forEach((test: any) => {
      if (test.completed) this.testsCompleted++;

      if (test.dimensions && Array.isArray(test.dimensions)) {
        // Contar todas las dimensiones
        dimensionsTotalCount += test.dimensions.length;

        // Contar las dimensiones completadas
        test.dimensions.forEach((dimension: any) => {
          if (dimension.completed) {
            this.dimensionsCompleted++;
          }
        });
      }
    });

    // Calculamos el porcentaje general de progreso de autoconocimiento
    this.autoconocimientoProgress =
      dimensionsTotalCount > 0
        ? Math.round((this.dimensionsCompleted / dimensionsTotalCount) * 100)
        : 0;

    // Actualizamos el estado de la sección "Descúbrete" en el dashboard
    // Si al menos una dimensión está completada, se considera en progreso
    this.progresoDescubrete = this.dimensionsCompleted > 0;

    // También actualizamos el PRD si hay suficiente progreso en autoconocimiento
    // Por ejemplo, si han completado al menos el 50% de las dimensiones
    this.progresoPRD = this.autoconocimientoProgress >= 50;

    console.log(
      `Progreso de autoconocimiento: ${this.autoconocimientoProgress}% (${this.dimensionsCompleted}/${dimensionsTotalCount} dimensiones completadas)`
    );
  }

  // Cargar datos básicos del usuario
  loadUserData() {
    // Debug temporal para ver la estructura del usuario
    console.log('=== LOAD USER DATA ===');
    console.log('Usuario completo:', this.user);
    console.log('Tipo de usuario:', this.user?.type);
    console.log('Tipo de suscripción:', this.user?.type?.suscriptionType);
    console.log('ID de suscripción:', this.user?.type?.suscriptionType?.id);
    console.log('Nombre de suscripción:', this.user?.type?.suscriptionType?.name);
    console.log('=== FIN LOAD USER DATA ===');

    // Verificar si el onboarding está completo (usando el objeto user completo)
    if (
      this.user &&
      this.user.profile &&
      this.user.profile.onboardingComplete
    ) {
      this.progresoOnboarding = true;
    }

    // Verificar rango salarial para mostrar modal Executive
    this.checkSuscriptionPublicityToShow();

    // Comprobar si el usuario es Freemium
    this.updateFreemiumStatus();

    // Para usuarios Freemium, mostrar horas en 0 según el requerimiento
    if (this.isUserFreemium()) {
      this.horasMentores = 0;
      this.horasExpertos = 0;
      this.horasTotalesMentores = 0;
      this.horasTotalesExpertos = 0;
    } else {
      // Para usuarios no Freemium, mostrar los valores reales o predeterminados
      this.horasMentores = 0;
      this.horasExpertos = 0;
      this.horasTotalesMentores = this.user?.type?.subscription?.coachHoursTotal || 0;
      this.horasTotalesExpertos = this.user?.type?.subscription?.expertHoursTotal || 0;
    }
  }

  loadAppointments() {
    if (!this.user?._id) {
      console.warn('Usuario no disponible para cargar citas');
      return;
    }

    this.appointmentsService.findByCustomer(this.user._id).subscribe({
      next: (res) => {
        this.userAppointments = res.data;
        this.setupCalendarOptions();
        this.updateMiniCalendar(); // Actualizar el calendario mensual con las nuevas citas
        this.updateAgenda();
      },
      error: (err) => {
        console.error('Error al cargar citas:', err);
      }
    })
  }

  cardClick(card: string) {
    switch (card) {
      case 'objetivos':
        this.router.navigate(["/dashboard/objectives"]);
        break;
      case 'mentor':
        this.router.navigate(["/dashboard/plans"]);
        break;
      case 'experto':
        this.router.navigate(["/dashboard/mentors"]);
        break;
      default:
        console.error("Unhandled cardClick: ", card);
        break;
    }
  }

  openHoursMentorModal() {
    this.showHoursMentorModal = true;
  }

  closeHoursMentorModal() {
    this.showHoursMentorModal = false;
  }

  // Método simplificado para procesar objetivos
  procesarObjetivos() {

    // Validate we have recieved objetives from the backend
    if (!this.objetivosOriginales || this.objetivosOriginales.length === 0) {
      console.log("No hay objetivos para mostrar");
      this.objetivos = [];
      this.objetivosFiltrados = [];
      return;
    }

    // Reset variables
    this.totalPorcentajeObjetivos = 0;
    this.totalObjetivos = 0;
    this.totalObjetivosCompletados = 0;
    this.objetivos = [];
    this.objetivosFiltrados = [];

    // Filter deleted objectives
    this.objetivosOriginales = this.objetivosOriginales.filter(obj => obj.state != 'Eliminado');

    // Mapear objetivos para la UI
    this.objetivos = this.objetivosOriginales.map((obj: any) => ({
      _id: obj._id || "",
      nombre: obj.name || "",
      dimension: obj.dimension?.name || "General",
      fin: this.formatDate(obj.end) || "Sin fecha",
      porcentaje: obj.percentage || 0,
      activities: this.procesarActividades(obj.activities),
      state: obj.state
    }));

    // Extraer actividades
    this.extraerActividades();

    // Aplicar filtro inicial
    this.filtrarObjetivos();

    // Actualizar porcentaje total y estadísticas
    if (this.objetivos.length > 0) {
      this.totalObjetivos = this.objetivos.length;
      this.totalObjetivosCompletados = this.objetivos.filter(obj => obj.state === 'Terminado').length;
      this.totalPorcentajeObjetivos = Math.round((this.totalObjetivosCompletados / this.objetivos.length) * 100);
      this.cards[0].progressValue = this.totalPorcentajeObjetivos;
    } else {
      this.totalObjetivos = 0;
      this.totalObjetivosCompletados = 0;
    }
  }

  // Nuevo método para filtrar objetivos por estado
  filtrarObjetivos() {
    if (this.estadoSeleccionado === "Todos") {
      this.objetivosFiltrados = [...this.objetivos];
    } else {
      this.objetivosFiltrados = this.objetivos.filter(
        (objetivo) =>
          objetivo.activities &&
          objetivo.activities.some(
            (actividad) => actividad.estado === this.estadoSeleccionado
          )
      );
    }
  }

  // Método simplificado para procesar actividades
  procesarActividades(activities?: any[]): ActividadUI[] {
    if (!activities || !Array.isArray(activities) || activities.length === 0) {
      return [];
    }

    return activities.map((act) => ({
      nombre: act.name || "",
      descripcion: act.description || "",
      progreso: this.calcularProgresoActividad(act),
      estado: this.obtenerEstadoActividad(act),
      inicio: act.start ? this.formatDate(act.start) : "Sin fecha",
      fin: act.end ? this.formatDate(act.end) : "Sin fecha",
    }));
  }

  // Simplificar cálculo de progreso
  calcularProgresoActividad(actividad: any): number {
    if (!actividad || !actividad.state) return 0;

    switch (actividad.state) {
      case "Terminado":
      case "Realizado":
      case "Completada":
      case "Completado":
        return 100;
      case "Empezado":
      case "En progreso":
        return 50;
      case "Pendiente":
      case "Nuevo":
      case "No empezado":
      default:
        return 0;
    }
  }

  // Simplificar obtención de estado
  obtenerEstadoActividad(actividad: any): string {
    if (!actividad || !actividad.state) return "Pendiente";

    switch (actividad.state) {
      case "Empezado":
        return "En progreso";
      case "Terminado":
      case "Realizado":
      case "Completado":
        return "Completada";
      case "No empezado":
        return "Pendiente";
      default:
        return actividad.state;
    }
  }

  // Extraer actividades de objetivos
  extraerActividades() {
    this.actividades = [];

    this.objetivos.forEach((objetivo) => {
      if (objetivo.activities && objetivo.activities.length > 0) {
        this.actividades.push(...objetivo.activities);
      }
    });
  }

  // Método para formatear fecha (como en ObjectivesComponent)
  formatDate(dateStr: string): string {
    if (!dateStr || dateStr.trim() === "") return "Sin fecha";

    try {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return "Sin fecha"; // Fecha inválida

      // Si la fecha es hoy o mañana
      const today = new Date();
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);

      if (date.toDateString() === today.toDateString()) {
        return "Hoy";
      } else if (date.toDateString() === tomorrow.toDateString()) {
        return "Mañana";
      } else {
        // Formato DD/MM/YYYY
        return `${date.getDate().toString().padStart(2, "0")}/${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
      }
    } catch (error) {
      console.error("Error al formatear fecha:", error);
      return "Sin fecha";
    }
  }

  // Método para obtener el rango de la semana actual
  getStartAndEndOfWeek(): { start: string; end: string } {
    const now = new Date();
    const dayOfWeek = now.getDay();

    console.log('now.getDay()', now.getDay());
    console.log('now.getUTCDay()', now.getUTCDay());

    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - dayOfWeek);
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    console.log('startOfWeek', startOfWeek);
    console.log('endOfWeek', endOfWeek);

    return {
      start: startOfWeek.toISOString().split("T")[0],
      end: endOfWeek.toISOString().split("T")[0],
    };
  }

  // Ocultar mensaje
  hideMessage() {
    this.messageHide = true;
  }

  // Método para manejar el cambio de fecha en el calendario
  onDateChange(date: Date) {
    console.log("Fecha seleccionada:", date);
  }

  // Navegar a la página de objetivos
  verTodosObjetivos() {
    this.router.navigate(["dashboard/objectives"]);
  }

  // Navegar a la página de autoconocimiento
  verAutoconocimiento() {
    // Solo permitir navegación para usuarios no Freemium
    if (this.isUserFreemium()) {
      return;
    }

    this.router.navigate(["dashboard/life-circle"]);
  }

  // Navegar a la página para crear un nuevo objetivo
  crearNuevoObjetivo() {
    console.log("Creando nuevo objetivo...");
    // Si el usuario es Freemium, no permitir la creación de objetivos
    if (this.isUserFreemium()) {
      //return;
    }

    this.router.navigate(["dashboard/new-objective"], {
      state: { objetivo: null, editable: true },
    });
  }

  // Navegar a la página PRD
  toPRD() {
    // Solo permitir navegación para usuarios no Freemium
    if (this.isUserFreemium()) {
      return;
    }

    this.router.navigate(["dashboard/prd"]);
  }

  // Navegar al Círculo de Vida (disponible para todos, incluso Freemium)
  toCircleOfLife() {
    this.router.navigate(["dashboard/life-map"]);
  }

  // Método para verificar si el usuario es Freemium
  isUserFreemium(): boolean {
    return this._isUserFreemium;
  }

  // Método privado para actualizar el estado Freemium
  private updateFreemiumStatus(): void {
    console.log('=== DEBUG updateFreemiumStatus ===');
    console.log('this.user:', this.user);
    console.log('this.user?.type:', this.user?.type);
    console.log('this.user?.type?.suscriptionType:', this.user?.type?.suscriptionType);
    console.log('SUBSCRIPTION_TYPES.Freemium.id:', SUBSCRIPTION_TYPES.Freemium.id);

    // Buscar en diferentes ubicaciones posibles
    const suscriptionType1 = this.user?.type?.suscriptionType;
    const suscriptionType2 = this.user?.suscriptionType;
    const suscriptionType3 = this.user?.subscription;

    console.log('suscriptionType1 (user.type.suscriptionType):', suscriptionType1);
    console.log('suscriptionType2 (user.suscriptionType):', suscriptionType2);
    console.log('suscriptionType3 (user.subscription):', suscriptionType3);

    this._isUserFreemium = !!(
      this.user &&
      this.user.type &&
      this.user.type.suscriptionType &&
      (this.user.type.suscriptionType.id == SUBSCRIPTION_TYPES.Freemium.id)
    );

    console.log('Resultado _isUserFreemium:', this._isUserFreemium);
    console.log('=== FIN DEBUG ===');
  }

  // Método para manejar el cambio de filtro desde el componente
  onFiltroChange(estado: string) {
    this.estadoSeleccionado = estado;
    this.filtrarObjetivos();
  }

  // Métodos para el calendario
  initializeWeekDays() {
    this.updateWeekDays();
    this.selectedDay = this.weekDays[0];
  }

  updateWeekDays() {
    const daysOfWeek = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    this.weekDays = [];

    for (let i = 0; i < 7; i++) {
      const date = new Date(this.currentWeekStart);
      date.setDate(this.currentWeekStart.getDate() + i);

      this.weekDays.push({
        name: daysOfWeek[i],
        date: `${date.getDate()}/${date.getMonth() + 1}`,
        fullDate: date
      });
    }

    // Inicializar el día móvil seleccionado
    this.initializeMobileSelectedDay();
  }

  getCurrentWeekRange(): string {
    if (this.weekDays.length === 0) return '';

    const startDate = this.weekDays[0].fullDate;
    const endDate = this.weekDays[6].fullDate;

    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    const month = months[startDate.getMonth()];
    const year = startDate.getFullYear();

    return `${startDay} - ${endDay} ${month} ${year}`;
  }

  navigateWeek(direction: number) {
    this.currentWeekStart.setDate(this.currentWeekStart.getDate() + (direction * 7));
    this.updateWeekDays();

    // Si estamos en vista diaria, mantener el mismo día de la semana seleccionado
    if (this.currentView === 'day' && this.selectedDayIndex < this.weekDays.length) {
      this.selectedDay = this.weekDays[this.selectedDayIndex];
    }

    // Actualizar estados del calendario
    this.updateCalendarStates();
  }

  navigateDay(direction: number) {
    const newIndex = this.selectedDayIndex + direction;
    if (newIndex >= 0 && newIndex < this.weekDays.length) {
      this.selectedDayIndex = newIndex;
      this.selectedDay = this.weekDays[newIndex];
      this.updateCalendarStates();
    }
  }

  changeView(view: 'week' | 'day') {
    this.currentView = view;
    if (view === 'day') {
      this.selectedDay = this.weekDays[this.selectedDayIndex];
    }
    this.updateCalendarStates();
  }

  goToToday() {
    console.log('goToToday: ejecutándose...');

    const today = new Date();
    const todayDayOfWeek = today.getDay(); // 0 = domingo, 1 = lunes, etc.

    console.log('goToToday: día de hoy es', todayDayOfWeek, '(', ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'][todayDayOfWeek], ')');

    // Calcular el inicio de la semana actual
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - todayDayOfWeek);

    console.log('goToToday: inicio de semana calculado:', startOfWeek);
    console.log('goToToday: semana actual mostrada:', this.currentWeekStart);

    // Si la semana actual es diferente a la mostrada, actualizar
    if (startOfWeek.getTime() !== this.currentWeekStart.getTime()) {
      console.log('goToToday: actualizando semana...');
      this.currentWeekStart = startOfWeek;
      this.updateWeekDays();
    } else {
      console.log('goToToday: semana ya está actualizada');
    }

    // Seleccionar el día actual
    this.selectedDayIndex = todayDayOfWeek;
    this.selectedDay = this.weekDays[todayDayOfWeek];

    console.log('goToToday: día seleccionado:', this.selectedDayIndex, 'objeto día:', this.selectedDay);

    // Cambiar a vista semanal para que el botón "Hoy" funcione correctamente
    if (this.currentView !== 'week') {
      console.log('goToToday: cambiando a vista semanal');
      this.currentView = 'week';
    }

    console.log('goToToday: completado. Vista actual:', this.currentView, 'Día seleccionado:', this.selectedDayIndex);

    // Actualizar estados del calendario
    this.updateCalendarStates();
  }

  isTodaySelected(): boolean {
    return this._isTodaySelected;
  }

  // Verificar si el día seleccionado es hoy (para uso interno)
  private isSelectedDayToday(): boolean {
    if (!this.selectedDay) return false;

    const today = new Date();
    const selectedDate = this.selectedDay.fullDate;

    return today.toDateString() === selectedDate.toDateString();
  }

  // Verificar si el botón "Día" está activo
  isDayViewActive(): boolean {
    return this._isDayViewActive;
  }

  // Método privado para actualizar los estados del calendario (evita bucles)
  private updateCalendarStates(): void {
    // Actualizar estado del botón "Hoy"
    if (!this.selectedDay) {
      this._isTodaySelected = false;
    } else {
      const today = new Date();
      const selectedDate = this.selectedDay.fullDate;

      if (this.currentView === 'day') {
        this._isTodaySelected = false;
      } else {
        const todayDayOfWeek = today.getDay(); // 0 = domingo, 1 = lunes, etc.
        const isTodayInWeek = this.selectedDayIndex === todayDayOfWeek;
        const isDateToday = today.toDateString() === selectedDate.toDateString();
        this._isTodaySelected = isTodayInWeek && isDateToday;
      }
    }

    // Actualizar estado del botón "Día"
    this._isDayViewActive = this.currentView === 'day';
  }

  // Alternar sidebar móvil del calendario
  toggleMobileSidebar(): void {
    this.showMobileSidebar = !this.showMobileSidebar;
  }

  selectTimeSlot(day: any, hour: string) {
    console.log(`Slot seleccionado: ${day.name} ${day.date} a las ${hour}:00`);

    // Si hay una cita en este slot, mostrar modal con detalles
    const appointment = this.getAppointment(day, hour);
    if (appointment) {
      this.selectedAppointment = appointment;
      this.generateMeetingDetails();
      this.showAppointmentModal = true;
    } else {
      // Si no hay cita, mostrar opción para crear una nueva
      console.log('Slot disponible para programar cita');
    }
  }

  hasEvent(day: any, hour: string): boolean {
    // Verificar si hay eventos en el userAppointments para este día y hora
    if (!this.userAppointments || !day) return false;

    const dayNumber = parseInt(day.date.split('/')[0]);
    const hourNumber = parseInt(hour);

    return this.userAppointments.some(appointment => {
      const appointmentDate = new Date(appointment.date + 'T' + appointment.time + ':00');
      const appointmentDay = appointmentDate.getDate();
      const appointmentHour = appointmentDate.getHours();

      return appointmentDay === dayNumber && appointmentHour === hourNumber;
    });
  }

  // Obtener la cita para un día y hora específicos
  getAppointment(day: any, hour: string): Appointment | undefined {
    if (!this.userAppointments || !day) return undefined;

    const dayNumber = parseInt(day.date.split('/')[0]);
    const hourNumber = parseInt(hour);

    return this.userAppointments.find(appointment => {
      const appointmentDate = new Date(appointment.date + 'T' + appointment.time + ':00');
      const appointmentDay = appointmentDate.getDate();
      const appointmentHour = appointmentDate.getHours();

      return appointmentDay === dayNumber && appointmentHour === hourNumber;
    });
  }

  // Obtener el nombre del coach para mostrar en el tooltip
  getCoachName(day: any, hour: string): string {
    const appointment = this.getAppointment(day, hour);
    return appointment ? appointment.coach.name : '';
  }

  // Obtener el tipo de coach (Coach o Experto)
  getCoachType(day: any, hour: string): string {
    const appointment = this.getAppointment(day, hour);
    return appointment ? appointment.coach.type.name : '';
  }

  // Obtener las próximas citas ordenadas por fecha
  getUpcomingAppointments(): Appointment[] {
    if (!this.userAppointments || this.userAppointments.length === 0) {
      return [];
    }

    const now = new Date();
    const upcoming = this.userAppointments.filter(appointment => {
      const appointmentDate = new Date(appointment.date + 'T' + appointment.time + ':00');
      return appointmentDate > now;
    });

    // Ordenar por fecha (más cercana primero)
    return upcoming.sort((a, b) => {
      const dateA = new Date(a.dateValue);
      const dateB = new Date(b.dateValue);
      return dateA.getTime() - dateB.getTime();
    }).slice(0, 3); // Mostrar solo las próximas 3 citas
  }

  // Navegar a la página de mentores para agendar cita
  goToMentors(): void {
    this.router.navigate(['/dashboard/mentors']);
  }

  // Verificar elegibilidad para Executive basado en rango salarial
  checkExecutiveEligibility() {
    console.log('checkExecutiveEligibility: ejecutándose...');
    console.log('user:', this.user);

    if (!this.user) {
      console.log('checkExecutiveEligibility: No hay usuario');
      return;
    }

    if (!this.user.professionalSection) {
      console.log('checkExecutiveEligibility: No hay professionalSection');
      return;
    }

    if (!this.user.professionalSection.professionalData) {
      console.log('checkExecutiveEligibility: No hay professionalData');
      return;
    }

    const salaryRange = this.user.professionalSection.professionalData.salaryRange;
    console.log('Rango salarial del usuario:', salaryRange);

    // Verificar si el rango salarial es mayor a 10k
    const highSalaryRanges = environment.highSalaryRanges;
    console.log('Rangos salariales altos:', highSalaryRanges);
    console.log('¿El rango del usuario está en la lista?', highSalaryRanges.includes(salaryRange));

    if (salaryRange && highSalaryRanges.includes(salaryRange)) {
      console.log('checkExecutiveEligibility: Usuario elegible para Executive');

      // Usuario con salario alto
      this.isHighSalaryUser = true;

      // Mostrar banner de felicitaciones
      this.showSalaryBanner = true;
      console.log('showSalaryBanner establecido en:', this.showSalaryBanner);

      // Verificar si ya se mostró el modal (usando localStorage)
      const modalShownKey = `executive-modal-shown-${this.user._id}`;
      const modalAlreadyShown = localStorage.getItem(modalShownKey);
      console.log('Modal ya mostrado:', modalAlreadyShown);
      console.log('Clave del localStorage:', modalShownKey);

      if (!modalAlreadyShown) {
        console.log('checkExecutiveEligibility: Mostrando modal Executive');
        this.showExecutiveModal = true;
        console.log('showExecutiveModal establecido en:', this.showExecutiveModal);

        // Marcar que ya se mostró el modal
        localStorage.setItem(modalShownKey, 'true');
        console.log('Modal marcado como mostrado en localStorage');
      } else {
        console.log('checkExecutiveEligibility: Modal ya fue mostrado anteriormente');
      }
    } else {
      console.log('checkExecutiveEligibility: Usuario NO elegible para Executive');
      console.log('Rango salarial:', salaryRange);
      console.log('Rangos altos:', highSalaryRanges);

      // Usuario con salario bajo
      this.isHighSalaryUser = false;

      // Mostrar banner de felicitaciones para Professional
      this.showSalaryBanner = true;
      console.log('showSalaryBanner establecido en:', this.showSalaryBanner);
    }
  }

  // Verificar elegibilidad para Executive basado en rango salarial
  checkSuscriptionPublicityToShow() {
    console.log('checkSuscriptionPublicityToShow: ejecutándose...');
    console.log('checkSuscriptionPublicityToShow: user is ', this.user);

    if (!this.user) {
      console.log('checkSuscriptionPublicityToShow: No hay usuario');
      return;
    }

    if (this.user.type && this.user.type.id != 1) {
      console.log('checkSuscriptionPublicityToShow: Usuario no es Cliente');
      return;
    }

    if (this.user.type.suscriptionType && this.user.type.suscriptionType.id != "1") {
      console.log('checkSuscriptionPublicityToShow: Usuario ya esta suscrito ', this.user.type);
      return;
    }

    // Show the Suscribe banner (Professional by default)
    this.showSalaryBanner = true;

    const questionSalary = this.user.profile.registerQuestions.find((q: any) =>
      q.title?.includes("¿En qué rango aproximado están tus ingresos  mensuales? Tu respuesta es confidencial y solo se usa para personalizar tu experiencia.")
    );

    // Validate Executive
    if (questionSalary.value != "5001-más USD") {
      return;
    }

    // Make the banner Executive
    console.log('Ready for Executive');
    this.isHighSalaryUser = true;

    // Show Modal Executive
    const modalShownKey = `executive-modal-shown-${this.user._id}`;
    const modalAlreadyShown = localStorage.getItem(modalShownKey);
    console.log('Modal ya mostrado:', modalAlreadyShown);
    console.log('Clave del localStorage:', modalShownKey);

    // Validate modalAlreadyShown
    if (modalAlreadyShown) {
      console.log('checkSuscriptionPublicityToShow: Modal ya fue mostrado anteriormente');
      return;
    }

    // Show Modal Executive
    console.log('checkSuscriptionPublicityToShow: Mostrando modal Executive');
    this.showExecutiveModal = true;
    console.log('showExecutiveModal establecido en:', this.showExecutiveModal);

    // Marcar que ya se mostró el modal
    localStorage.setItem(modalShownKey, 'true');
    console.log('Modal marcado como mostrado en localStorage');
  }

  // Método de prueba para forzar la visualización del modal Executive
  testExecutiveModal() {
    console.log('testExecutiveModal: Forzando visualización del modal');
    this.showExecutiveModal = true;
    console.log('showExecutiveModal establecido en:', this.showExecutiveModal);
  }

  // Cerrar modal Executive
  closeExecutiveModal() {
    this.showExecutiveModal = false;
  }

  // Redirigir a WhatsApp para agendar entrevista
  scheduleInterview() {
    const userName = this.user?.firstName || this.user?.name || 'Usuario';
    const message = environment.whatsapp.executiveMessage.replace('{userName}', userName);
    const phoneNumber = environment.whatsapp.phoneNumber;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    // Abrir WhatsApp en nueva ventana
    window.open(whatsappUrl, '_blank');

    // Cerrar el modal
    this.closeExecutiveModal();
  }

  // Obtener nombre del usuario para el modal
  getUserFirstName(): string {
    return this.user?.firstName || this.user?.name || 'Usuario';
  }

  // Obtener URL de la imagen del modal Executive
  getExecutiveModalImageUrl(): string {
    const baseUrl = environment.apiUrlClean;
    return `${baseUrl}/executive-bg.jpg`;
  }

  // Obtener URL del video de Phoenix Professional
  getProfessionalVideoUrl(): string {
    return environment.urlVideoProfessional;
  }

  // Obtener ID del video de Phoenix Professional para el reproductor de YouTube
  getProfessionalVideoId(): string {
    return YouTubePlayerComponent.extractVideoId(this.getProfessionalVideoUrl()) || '';
  }

  // Obtener parámetros del video para el reproductor de YouTube
  getVideoParams(): string {
    return 'autoplay=0&mute=0&enablejsapi=1&origin=' + window.location.origin + '&rel=0&showinfo=0';
  }

  // Cerrar banner de felicitaciones
  closeSalaryBanner() {
    this.showSalaryBanner = false;
  }

  // Agendar entrevista desde banner
  scheduleInterviewFromBanner() {
    const userName = this.user?.firstName || this.user?.name || 'Usuario';
    const message = environment.whatsapp.executiveMessage.replace('{userName}', userName);
    const phoneNumber = environment.whatsapp.phoneNumber;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    // Abrir WhatsApp en nueva ventana
    window.open(whatsappUrl, '_blank');
  }

  // Abrir modal de lista de espera
  openWaitlistModal() {
    // Pre-llenar algunos campos con información del usuario si está disponible
    if (this.user) {
      this.waitlistForm.nombre = this.user.firstName || '';
      this.waitlistForm.apellido = this.user.lastName || '';
      this.waitlistForm.correoElectronico = this.user.email || '';
      this.waitlistForm.telefono = this.user.phone || '';
    }
    this.showWaitlistModal = true;
  }

  // Abrir modal de resumen de compras
  openModalPurchaseSummary() {
    this.showModalPurchaseSummary = true;
    this.updatePagination();
  }

  closeModalPurchaseSummary() {
    this.showModalPurchaseSummary = false;
  }

  // Ordenamiento
  sortBy(field: string) {

    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }

    this.userAppointments.sort((a, b) => {
      let aValue: any;
      let bValue: any;

      switch (field) {
        case 'date':
          aValue = this.parseDDMMYYYY(this.parseDateLineToDash(a.date) || '');
          bValue = this.parseDDMMYYYY(this.parseDateLineToDash(b.date) || '');
          break;
        case 'expert':
          aValue = a.coach.name;
          bValue = b.coach.name;
          break;
        case 'type':
          aValue = a.coach.type.name;
          bValue = b.coach.type.name;
          break;
        default:
          return 0;
      }

      console.log("sortBy", field + ":", aValue, "|", bValue);

      if (aValue < bValue) return this.sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.updatePagination();
  }

  parseDateLineToDash(dateStr: string): string | null {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split('-').map(Number);
    return `${day}/${month}/${month}`;
  }

  parseDDMMYYYY(dateStr: string): Date | null {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }

  // Paginación
  updatePagination() {
    this.totalPages = Math.ceil(this.userAppointments.length / this.itemsPerPage);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedData = this.userAppointments.slice(startIndex, endIndex);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updatePagination();
  }

  // Método para obtener las páginas visibles alrededor de la página actual
  getVisiblePages(): number[] {
    const visiblePages: number[] = [];
    const maxVisiblePages = 5; // Máximo número de páginas a mostrar

    if (this.totalPages <= maxVisiblePages) {
      // Si hay pocas páginas, mostrar todas
      for (let i = 2; i < this.totalPages; i++) {
        visiblePages.push(i);
      }
    } else {
      // Lógica para mostrar páginas alrededor de la actual
      const start = Math.max(2, this.currentPage - 1);
      const end = Math.min(this.totalPages - 1, this.currentPage + 1);

      // Asegurar que siempre mostremos al menos 2-3 páginas en el medio
      let actualStart = start;
      let actualEnd = end;

      if (this.currentPage <= 3) {
        // Si estamos cerca del inicio, mostrar más páginas al final
        actualEnd = Math.min(this.totalPages - 1, 4);
      } else if (this.currentPage >= this.totalPages - 2) {
        // Si estamos cerca del final, mostrar más páginas al inicio
        actualStart = Math.max(2, this.totalPages - 3);
      }

      for (let i = actualStart; i <= actualEnd; i++) {
        visiblePages.push(i);
      }
    }

    return visiblePages;
  }

  // Método para obtener el texto de elementos mostrados
  getDisplayedItemsText(): string {
    if (this.userAppointments.length === 0) {
      return '0';
    }

    const startItem = (this.currentPage - 1) * this.itemsPerPage + 1;
    const endItem = Math.min(this.currentPage * this.itemsPerPage, this.userAppointments.length);

    if (startItem === endItem) {
      return `${startItem}`;
    }

    return `${startItem}-${endItem}`;
  }

  // Cerrar modal de lista de espera
  closeWaitlistModal() {
    this.showWaitlistModal = false;
    this.resetWaitlistForm();
  }

  // Resetear formulario de lista de espera
  resetWaitlistForm() {
    this.waitlistForm = {
      nombre: '',
      apellido: '',
      telefono: '',
      correoElectronico: '',
      provincia: '',
      distrito: ''
    };
  }

  // Obtener distritos por provincia
  getDistritosByProvincia(): string[] {
    if (this.waitlistForm.provincia && this.distritos[this.waitlistForm.provincia]) {
      return this.distritos[this.waitlistForm.provincia];
    }
    return [];
  }

  // Limpiar distrito cuando cambia la provincia
  onProvinciaChange() {
    this.waitlistForm.distrito = '';
  }

  // Validar formulario de lista de espera
  isWaitlistFormValid(): boolean {
    return !!(
      this.waitlistForm.nombre?.trim() &&
      this.waitlistForm.apellido?.trim() &&
      this.waitlistForm.telefono?.trim() &&
      this.waitlistForm.correoElectronico?.trim() &&
      this.waitlistForm.provincia?.trim() &&
      this.waitlistForm.distrito?.trim()
    );
  }

  // Método para mostrar alertas
  alert(message: string, title: string = ""): void {
    Swal.fire({
      title: title,
      html: message,
      confirmButtonText: 'Aceptar',
      customClass: {
        container: 'alert-container',
        confirmButton: 'alert-confirmButton'
      }
    });
  }

  // Enviar formulario de lista de espera
  async submitWaitlistForm() {
    if (!this.isWaitlistFormValid()) {
      this.alert('Por favor, completa todos los campos requeridos.');
      return;
    }

    this.isSubmittingWaitlist = true;
    this.loader.show();

    try {
      // Preparar datos para enviar
      const waitlistData = {
        ...this.waitlistForm,
        userId: this.authUser?.id || undefined,
        createdAt: new Date().toISOString()
      };

      // Llamar al servicio de waitlist
      await this.waitlistService.registerToWaitlist(waitlistData).toPromise();

      this.closeWaitlistModal();
      this.alert('¡Gracias! Te has registrado exitosamente en nuestra lista de espera. Te contactaremos pronto.');
    } catch (error) {
      console.error('Error al registrar en lista de espera:', error);
      this.alert('Hubo un error al registrar tu solicitud. Por favor, intenta nuevamente.');
    } finally {
      this.isSubmittingWaitlist = false;
      this.loader.hide();
    }
  }

  // ===== FUNCIONES DEL CALENDARIO MENSUAL =====

  // Inicializar el calendario mensual
  initializeMiniCalendar() {
    this.updateMiniCalendar();
  }

  // Actualizar el calendario mensual
  updateMiniCalendar() {
    const year = this.currentMonth.getFullYear();
    const month = this.currentMonth.getMonth();

    // Obtener el primer día del mes
    const firstDay = new Date(year, month, 1);
    // Obtener el último día del mes
    const lastDay = new Date(year, month + 1, 0);

    // Obtener el día de la semana del primer día (0 = domingo, 1 = lunes, etc.)
    const firstDayOfWeek = firstDay.getDay();
    // Obtener el número total de días en el mes
    const totalDays = lastDay.getDate();

    // Generar el array de días del calendario
    this.miniCalendarDays = [];

    // Agregar días del mes anterior para completar la primera semana
    const prevMonth = new Date(year, month - 1, 0);
    const prevMonthDays = prevMonth.getDate();
    for (let i = firstDayOfWeek - 1; i >= 0; i--) {
      this.miniCalendarDays.push({
        day: prevMonthDays - i,
        isOtherMonth: true,
        isToday: false,
        hasEvent: false,
        date: new Date(year, month - 1, prevMonthDays - i)
      });
    }

    // Agregar días del mes actual
    const today = new Date();
    for (let i = 1; i <= totalDays; i++) {
      const currentDate = new Date(year, month, i);
      const isToday = today.toDateString() === currentDate.toDateString();
      const hasEvent = this.hasEventOnDate(currentDate);

      this.miniCalendarDays.push({
        day: i,
        isOtherMonth: false,
        isToday: isToday,
        hasEvent: hasEvent,
        date: currentDate
      });
    }

    // Agregar días del mes siguiente para completar la última semana
    const remainingSlots = 42 - this.miniCalendarDays.length; // 6 semanas * 7 días = 42
    for (let i = 1; i <= remainingSlots; i++) {
      this.miniCalendarDays.push({
        day: i,
        isOtherMonth: true,
        isToday: false,
        hasEvent: false,
        date: new Date(year, month + 1, i)
      });
    }

    // Actualizar el texto del mes y año
    this.updateMonthYearText();
  }

  // Verificar si hay eventos en una fecha específica
  hasEventOnDate(date: Date): boolean {
    if (!this.userAppointments || this.userAppointments.length === 0) {
      return false;
    }

    const targetDate = date.toDateString();
    return this.userAppointments.some(appointment => {
      const appointmentDate = new Date(appointment.date + 'T00:00:00');
      return appointmentDate.toDateString() === targetDate;
    });
  }

  // Actualizar el texto del mes y año
  updateMonthYearText() {
    const months = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'];
    const month = months[this.currentMonth.getMonth()];
    const year = this.currentMonth.getFullYear();
    this.currentMonthYear = `${month}. ${year}`;
  }

  // Navegar al mes anterior
  navigateMonth(direction: number) {
    this.currentMonth.setMonth(this.currentMonth.getMonth() + direction);
    this.updateMiniCalendar();
  }

  // Seleccionar un día del calendario mensual
  selectMiniCalendarDay(dayData: any) {
    // Evitar bucles infinitos
    if (this._isNavigatingMonth) {
      return;
    }

    if (dayData.isOtherMonth) {
      // Si es de otro mes, navegar a ese mes
      const targetDate = dayData.date;
      const targetMonth = targetDate.getMonth();
      const targetYear = targetDate.getFullYear();
      const currentMonth = this.currentMonth.getMonth();
      const currentYear = this.currentMonth.getFullYear();

      // Calcular la diferencia de meses
      const monthDiff = (targetYear - currentYear) * 12 + (targetMonth - currentMonth);

      if (monthDiff !== 0) {
        this._isNavigatingMonth = true;

        // Navegar al mes correcto
        this.currentMonth.setMonth(this.currentMonth.getMonth() + monthDiff);
        this.updateMiniCalendar();

        // Seleccionar el día después de navegar
        setTimeout(() => {
          this._isNavigatingMonth = false;

          // Buscar el día correspondiente en el nuevo calendario
          const dayNumber = targetDate.getDate();
          const newDayData = this.miniCalendarDays.find(day =>
            day.day === dayNumber &&
            !day.isOtherMonth &&
            day.date.getDate() === dayNumber
          );

          if (newDayData) {
            this.selectMiniCalendarDay(newDayData);
          }
        }, 100);
      }
      return;
    }

    // Actualizar la semana del calendario principal para mostrar el día seleccionado
    const selectedDate = dayData.date;
    const dayOfWeek = selectedDate.getDay(); // 0 = domingo, 1 = lunes, etc.

    // Calcular el inicio de la semana que contiene el día seleccionado
    const startOfWeek = new Date(selectedDate);
    startOfWeek.setDate(selectedDate.getDate() - dayOfWeek);

    // Actualizar la semana actual del calendario principal
    this.currentWeekStart = startOfWeek;
    this.updateWeekDays();

    // Cambiar a vista semanal y seleccionar el día
    this.currentView = 'week';
    this.selectedDayIndex = dayOfWeek;
    this.selectedDay = this.weekDays[dayOfWeek];

    // Actualizar también el día seleccionado en el calendario móvil
    this.mobileSelectedDayIndex = dayOfWeek;
    this.mobileSelectedDay = this.weekDays[dayOfWeek];

    // Hacer scroll al calendario principal
    this.scrollToCalendar();
  }

  // Hacer scroll al calendario principal
  scrollToCalendar() {
    const calendarElement = document.querySelector('.calendario-semanal') || document.querySelector('.calendario-mobile');
    if (calendarElement) {
      calendarElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  // Cambiar a vista de mes
  changeToMonthView() {
    this.currentView = 'month';
    this.updateMiniCalendar();
  }

  // Verificar si un día está seleccionado
  isSelectedDay(dayData: any): boolean {
    if (!dayData || dayData.isOtherMonth) return false;

    // Verificar si está seleccionado en el calendario principal
    if (this.currentView === 'week' && this.selectedDay) {
      return this.selectedDay.fullDate.toDateString() === dayData.date.toDateString();
    }

    // Verificar si está seleccionado en el calendario móvil
    if (this.isMobileView() && this.mobileSelectedDay) {
      return this.mobileSelectedDay.fullDate.toDateString() === dayData.date.toDateString();
    }

    return false;
  }

  // Agenda

  updateAgenda() {
    if (!this.userAppointments || this.userAppointments.length === 0) {
      this.agenda = [];
      return;
    }

    // Agrupar eventos por día
    const agenda: { [key: string]: any } = {};

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    this.userAppointments.forEach(appointment => {
      // Crear fecha local sin problemas de zona horaria
      let appointmentDate: Date;
      if (appointment.date.includes('-')) {
        // Formato YYYY-MM-DD
        const dateParts = appointment.date.split('-');
        appointmentDate = new Date(
          parseInt(dateParts[0]),
          parseInt(dateParts[1]) - 1,
          parseInt(dateParts[2])
        );
      } else {
        // Otros formatos, usar Date normal
        appointmentDate = new Date(appointment.date);
      }

      // skip past appointments
      if (appointmentDate < today) {
        return;
      }

      const dayKey = appointmentDate.toDateString();

      if (!agenda[dayKey]) {
        agenda[dayKey] = {
          dayName: this.getEventDayName(appointmentDate),
          date: this.formatEventDate(appointmentDate),
          dateObj: appointmentDate, // Guardar la fecha para ordenar
          events: []
        };
      }

      agenda[dayKey].events.push({
        time: appointment.time,
        category: appointment.coach.type.name,
        title: appointment.coach.name
      });
    });

    // Convertir a array y ordenar por fecha
    this.agenda = Object.values(agenda).sort((a: any, b: any) => {
      // Ordenar usando el dateObj guardado
      return a.dateObj.getTime() - b.dateObj.getTime();
    });

    console.log("agenda:", this.agenda);

  }

  getEventDayName(date: Date): string {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    return days[date.getDay()];
  }

  formatEventDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day} de ${month}, ${year}`;
  }

  onAgendaItemClick(day: any, event: any) {
    //format the day in order to search it with getAppointment
    const dayNum = day.dateObj.getDate().toString().padStart(2, "0");
    const monthNum = (day.dateObj.getMonth() + 1).toString().padStart(2, "0");
    const formatted = `${dayNum}/${monthNum}`;
    const auxDay = { 'date': formatted };

    // get and validate the appointment
    const appointment = this.getAppointment(auxDay, event.time);
    if (!appointment) return;

    // show the appointment Modal
    this.selectedAppointment = appointment;
    this.generateMeetingDetails();
    this.showAppointmentModal = true;
  }

  // ===== FUNCIONES DEL MODAL DE CITAS =====

  // Generar detalles de la reunión una sola vez
  private generateMeetingDetails(): void {
    console.log('selectedAppointment', this.selectedAppointment);
    // Usar el ID del appointment como meetingId
    this.meetingId = this.selectedAppointment?._id || '';
    //this.accessCode = Math.floor(Math.random() * 900000) + 100000 + '';
    // Usar la URL del environment
    this.meetingLink = `${environment.meetingUrl}${this.meetingId}`;
  }

  // Cerrar modal de detalles de cita
  closeAppointmentModal(): void {
    this.showAppointmentModal = false;
    this.selectedAppointment = null;
    // Limpiar los valores generados
    this.meetingId = '';
    this.accessCode = '';
    this.meetingLink = '';
  }

  // Obtener ID de reunión generado
  getMeetingId(): string {
    return this.meetingId;
  }

  // Obtener código de acceso generado
  getAccessCode(): string {
    return this.accessCode;
  }

  // Obtener enlace de reunión generado
  getMeetingLink(): string {
    return `${environment.meetingUrl}${this.meetingId.substring(0, 5)}...`;
  }

  // Unirse a la reunión
  joinMeeting(): void {
    window.open(this.meetingLink, '_blank');
  }

  // Copiar enlace de la reunión
  copyMeetingLink(): void {
    navigator.clipboard.writeText(this.meetingLink).then(() => {
      // Mostrar notificación de éxito
      console.log('Enlace copiado al portapapeles');
      // Aquí podrías mostrar un toast o notificación
    }).catch(err => {
      console.error('Error al copiar enlace:', err);
    });
  }

  // Enviar información de la cita por email
  sendAppointmentInfoByEmail(): void {
    if (!this.selectedAppointment || !this.user) {
      console.error('No hay cita seleccionada o usuario disponible');
      return;
    }

    // Mostrar loading
    this.loader.show();

    // Preparar datos del email
    const emailData: EmailData = {
      to: this.user.email,
      subject: 'Información de tu cita con Phoenix - Detalles de la reunión',
      template: 'appointment-info',
      data: {
        clientName: this.user.firstName || this.user.name || 'Cliente',
        mentorName: this.selectedAppointment.coach.name,
        sessionDate: this.selectedAppointment.date.toString(),
        sessionTime: this.selectedAppointment.time.toString(),
        meetingId: this.meetingId,
        accessCode: this.getAccessCode(),
        meetingLink: this.meetingLink,
        coachType: this.selectedAppointment.coach.type.name
      }
    };

    // Enviar el email
    this.emailService.sendAppointmentConfirmation(emailData).subscribe({
      next: (response) => {
        this.loader.hide();
        console.log('Email enviado exitosamente:', response);

        // Mostrar mensaje de éxito
        Swal.fire({
          title: '¡Email enviado!',
          text: 'La información de tu cita ha sido enviada a tu correo electrónico.',
          icon: 'success',
          confirmButtonText: 'Aceptar',
          customClass: {
            container: 'alert-container',
            confirmButton: 'alert-confirmButton'
          }
        });
      },
      error: (error) => {
        this.loader.hide();
        console.error('Error al enviar email:', error);

        // Mostrar mensaje de error
        Swal.fire({
          title: 'Error al enviar email',
          text: 'No se pudo enviar la información por correo. Por favor, intenta nuevamente.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
          customClass: {
            container: 'alert-container',
            confirmButton: 'alert-confirmButton'
          }
        });
      }
    });
  }

  // Formatear fecha de la cita
  private formatAppointmentDate(dateValue: string): string {
    try {
      const date = new Date(dateValue);
      return date.toLocaleDateString('es-ES', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return 'Fecha no disponible';
    }
  }

  // Formatear hora de la cita
  private formatAppointmentTime(dateValue: string): string {
    try {
      const date = new Date(dateValue);
      return date.toLocaleTimeString('es-ES', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'America/Lima'
      });
    } catch (error) {
      console.error('Error al formatear hora:', error);
      return 'Hora no disponible';
    }
  }

  // Métodos para el componente table
  onObjetivoDeleted(id: string): void {
    // Recargar la lista de objetivos después de eliminar uno
    this.reloadObjectivesFromService();
  }

  onDesignResponsive(isResponsive: boolean): void {
    // Manejar cambios de diseño responsive si es necesario
    console.log('Diseño responsive:', isResponsive);
  }

  onStateChanged(): void {
    // Recargar objetivos cuando cambie el estado
    this.reloadObjectivesFromService();
  }

  reloadObjectivesList(): void {
    // Recargar la lista completa de objetivos
    this.reloadObjectivesFromService();
  }

  private reloadObjectivesFromService(): void {
    // Recargar objetivos desde el servicio
    this.objectivesService.findAll(this.authUser.id).subscribe({
      next: (response) => {
        if (response && response.data && Array.isArray(response.data)) {
          this.objetivosOriginales = response.data;
          this.procesarObjetivos();
        }
      },
      error: (error) => {
        console.error("Error al recargar objetivos:", error);
      }
    });
  }

  // ===== FUNCIONES DEL BOTÓN FLOTANTE Y MODAL DE VIDEO =====

  // Verificar si debe reproducir el video automáticamente
  private checkAutoPlayVideo(): void {
    // Verificar que el usuario esté disponible antes de continuar
    if (!this.user) {
      console.warn('Usuario no disponible en checkAutoPlayVideo');
      return;
    }

    // Verificar si viene del flujo de completar perfil
    const fromProfileComplete = sessionStorage.getItem('fromProfileComplete');
    console.log('fromProfileComplete', fromProfileComplete);
    console.log('user?.isCompleteInfo', this.user?.isCompleteInfo);

    if (fromProfileComplete === 'true' && this.user?.isCompleteInfo) {
      this.shouldAutoPlayVideo = true;
      // Limpiar la bandera
      sessionStorage.removeItem('fromProfileComplete');

      // Esperar un poco para que el DOM esté listo y luego abrir el modal
      setTimeout(() => {
        this.onFloatingButtonClick();
      }, 1000);
    }
  }

  // Click en el botón flotante
  onFloatingButtonClick(): void {
    this.showVideoModal = true;
    console.log('Modal de video abierto desde dashboard-menu');
  }

  // Cerrar modal de video
  closeVideoModal(): void {
    this.showVideoModal = false;
    console.log('Modal de video cerrado');
  }

  // Obtener tooltip del botón flotante
  getFloatingButtonTooltip(): string {
    return 'Ver video de bienvenida';
  }

  // Método para ver objetivos
  viewObjectives(): void {
    this.router.navigate(['/dashboard/objectives']);
  }

  // Métodos para el calendario móvil
  isMobileView(): boolean {
    return window.innerWidth <= 768;
  }

  getMobileSelectedDay(): any {
    if (this.mobileSelectedDay) {
      return this.mobileSelectedDay;
    }
    // Si no hay día móvil seleccionado, usar el día actual de la semana
    return this.weekDays[this.mobileSelectedDayIndex] || this.weekDays[0];
  }

  getMobileSelectedDayName(): string {
    const day = this.getMobileSelectedDay();
    if (day) {
      return day.name;
    }

    // Si no hay día seleccionado, detectar el día actual
    const today = new Date();
    const todayDayOfWeek = today.getDay(); // 0 = domingo, 1 = lunes, etc.
    const daysOfWeek = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    console.log('todayDayOfWeek', todayDayOfWeek);
    return daysOfWeek[todayDayOfWeek];
  }

  getMobileSelectedDayDate(): string {
    const day = this.getMobileSelectedDay();
    return day ? day.date : '9/10';
  }

  navigateMobileDay(direction: number): void {
    const newIndex = this.mobileSelectedDayIndex + direction;
    if (newIndex >= 0 && newIndex < this.weekDays.length) {
      this.mobileSelectedDayIndex = newIndex;
      this.mobileSelectedDay = this.weekDays[newIndex];

      // Actualizar también el día seleccionado en el calendario principal
      this.selectedDayIndex = newIndex;
      this.selectedDay = this.weekDays[newIndex];

      // Actualizar el mini-calendario para reflejar el día seleccionado
      this.updateMiniCalendarSelection();
    }
  }

  // Inicializar el día móvil seleccionado
  initializeMobileSelectedDay(): void {
    if (this.weekDays.length > 0) {
      // Solo inicializar la primera vez (cuando el índice es -1)
      if (this.mobileSelectedDayIndex === -1) {
        // Detectar el día actual de la semana
        const today = new Date();
        const todayDayOfWeek = today.getDay(); // 0 = domingo, 1 = lunes, etc.

        console.log('initializeMobileSelectedDay - día actual:', todayDayOfWeek, 'nombre:', ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'][todayDayOfWeek]);

        this.mobileSelectedDayIndex = todayDayOfWeek;
        this.mobileSelectedDay = this.weekDays[todayDayOfWeek];

        console.log('mobileSelectedDay configurado a:', this.mobileSelectedDay);
      } else {
        // Ya está inicializado, solo actualizar el objeto día si cambia la semana
        if (this.mobileSelectedDayIndex < this.weekDays.length) {
          this.mobileSelectedDay = this.weekDays[this.mobileSelectedDayIndex];
        }
      }

      // Sincronizar con el mini-calendario
      this.updateMiniCalendarSelection();
    }
  }

  // Actualizar la selección del mini-calendario para reflejar el día seleccionado
  updateMiniCalendarSelection(): void {
    if (!this.mobileSelectedDay || !this.mobileSelectedDay.fullDate) return;

    const selectedDate = this.mobileSelectedDay.fullDate;
    const selectedDay = selectedDate.getDate();
    const selectedMonth = selectedDate.getMonth();
    const selectedYear = selectedDate.getFullYear();

    // Verificar si el día seleccionado está en el mes actual del mini-calendario
    const currentMonth = this.currentMonth.getMonth();
    const currentYear = this.currentMonth.getFullYear();

    if (selectedMonth !== currentMonth || selectedYear !== currentYear) {
      // Si el día seleccionado está en otro mes, navegar a ese mes
      this.currentMonth = new Date(selectedYear, selectedMonth, 1);
      this.updateMiniCalendar();
    }
  }
}
